import React, { useEffect, useRef, useState } from 'react'
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import { Dropdown, Menu, Spin } from 'antd'
import { CommentOutlined } from '@ant-design/icons'
import { GENERAL } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import PivotTableUX from 'components/PivotTable/PivotTableUX'
import PlaneTableUX from 'components/PivotTable/PlaneTableUX'
import PlaneTableRenderers from 'components/PivotTable/Renderers/Base/Plane'
import PivotTableRenderers from 'components/PivotTable/Renderers/Base/Tree'
import _, { isEqual } from 'lodash'
import { sortAs } from 'react-pivottable/Utilities'

import '../../../../../components/PivotTable/pivottable.css'
import './NestedTable.scss'
import { getHashTable, setFormatNumber } from 'modules/core/utils'
import { connect } from 'react-redux'
import login from 'modules/login'

const NestedTable = ({
  dataNestedTable,
  tableLoading,
  onCellEdit,
  canDelete,
  settings,
  setSettings,
  hasComment,
  setHasComment,
  setViewComment,
  visibleTotal = true,
  url,
  showTableqp,
  setShowTableqp,
  hash,
  setHash,
  loggedUser,
  tabKey,
}) => {
  const [dataCell, setDataCell] = useState({})
  const enabledPlaneTable = useFeatureIsOn('feature-plane-table')
  const enableFormatNumber = useFeatureIsOn('enable-format-number')
  const formatBaseNumber = useFeatureValue('format-number-table', 'Suma (Decimales)')
  const { t } = useTranslation()
  const inputValueRef = useRef(null)
  const sortStrictFilterRandstad = {
    Cuenta: sortAs(['Venta Total', 'Colaboradores (EW)', 'Placements']),
  }

  let queryString = window.location.search
  let urlParams = new URLSearchParams(queryString)
  let table = urlParams.get('table')

  useEffect(() => {
    if (table) {
      const data = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(data, 'base64').toString()
      const dataTable = JSON.parse(json)
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }
  }, [table, hash])

  useEffect(() => {
    if (showTableqp) {
      const { data, ...restProps } = settings
      if (!_.isEmpty(restProps)) {
        window.history.replaceState(null, '', `${url}`) //?table=${getHashTable(settings)}`)
      }
    }
  }, [settings, showTableqp, url])

  useEffect(() => {
    setSettings((prevState) => ({ ...prevState, data: dataNestedTable.data }))
  }, [dataNestedTable])

  if (enabledPlaneTable) {
    return (
      <Spin spinning={tableLoading}>
        <Dropdown
          trigger={['contextMenu']}
          overlay={
            <Menu>
              {GENERAL.OPTION_COMMENT.map((el) => (
                <Menu.Item
                  key={el.key}
                  icon={<CommentOutlined />}
                  onClick={() => {
                    setViewComment(true)
                    setHasComment({ type: 'table', data: !hasComment.table })
                  }}
                >
                  {t(el.label)}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <div style={{ width: '100%' }}>
            <PlaneTableUX
              renderers={Object.assign({}, PlaneTableRenderers)}
              data={dataNestedTable.data}
              onChange={(s) => {
                setHash(getHashTable(s, tabKey))
                setSettings(s)
                setShowTableqp(true)
              }}
              numberFormat={(val) => (enableFormatNumber ? setFormatNumber(loggedUser, val) : val)}
              vals={settings.default_value ? [settings.default_value] : ['amount']}
              cols={dataNestedTable.fields.columns}
              rows={dataNestedTable.fields.rows_default}
              aggregatorName={settings.default_format || formatBaseNumber}
              hiddenFromDragDrop={dataNestedTable.fields.values}
              hiddenFromAggregators={
                dataNestedTable?.data[0] &&
                dataNestedTable?.data[0].filter(
                  (el) => el !== 'amount' && el !== 'price' && el !== 'quantity',
                )
              }
              tableFilter={{}}
              plotlyConfig={{
                responsive: true,
              }}
              tableOptions={{
                realMonths: dataNestedTable.fields?.real_months,
                visibleTotal: visibleTotal,
                clickCallback: (info, value, record, pivotData, vals) => {
                  if (canDelete) {
                    if (_.isEmpty(dataCell) && info.target.className !== 'pvtTotal') {
                      setDataCell(record)

                      const originElement = info.target.innerHTML
                      const newElement = info.target

                      newElement.innerHTML = `<input type="text" value="${value ?? 0}" />`
                      const inputElement = document.querySelector('input[type="text"]')

                      inputElement.focus()

                      const handleInput = (e) => {
                        inputValueRef.current = e.target.value
                      }

                      const handleBlur = () => {
                        newElement.innerHTML = originElement
                        inputElement.removeEventListener('input', handleInput)
                        inputElement.removeEventListener('blur', handleBlur)
                        inputElement.removeEventListener('keypress', handleKeyPress)
                        setDataCell({})
                        inputValueRef.current = null
                      }

                      const handleKeyPress = (e) => {
                        if (e.key === 'Enter') {
                          onCellEdit(
                            parseFloat(inputValueRef.current),
                            record,
                            pivotData.props.vals[0],
                            'base',
                          )
                          inputElement.removeEventListener('input', handleInput)
                          inputElement.removeEventListener('blur', handleBlur)
                          inputElement.removeEventListener('keypress', handleKeyPress)
                          setDataCell({})
                          newElement.innerHTML = originElement
                        }
                      }

                      inputElement.addEventListener('input', handleInput)
                      inputElement.addEventListener('blur', handleBlur)
                      inputElement.addEventListener('keypress', handleKeyPress)
                    }
                  }
                },
              }}
              {...settings}
            />
          </div>
        </Dropdown>
      </Spin>
    )
  }

  return (
    <Spin spinning={tableLoading}>
      <Dropdown
        trigger={['contextMenu']}
        overlay={
          <Menu>
            {GENERAL.OPTION_COMMENT.map((el) => (
              <Menu.Item
                key={el.key}
                icon={<CommentOutlined />}
                onClick={() => {
                  setViewComment(true)
                  setHasComment({ type: 'table', data: !hasComment.table })
                }}
              >
                {t(el.label)}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <div style={{ width: '100%' }}>
          <PivotTableUX
            renderers={Object.assign({}, PivotTableRenderers)}
            data={dataNestedTable.data}
            onChange={(s) => {
              setHash(getHashTable(s, tabKey))
              setSettings(s)
              setShowTableqp(true)
            }}
            numberFormat={(val) => (enableFormatNumber ? setFormatNumber(loggedUser, val) : val)}
            vals={settings.default_value ? [settings.default_value] : ['amount']}
            cols={dataNestedTable.fields.columns}
            rows={dataNestedTable.fields.rows_default}
            aggregatorName={settings.default_format || formatBaseNumber}
            hiddenFromDragDrop={dataNestedTable.fields.values}
            hiddenFromAggregators={
              dataNestedTable?.data[0] &&
              dataNestedTable?.data[0].filter(
                (el) => el !== 'amount' && el !== 'price' && el !== 'quantity',
              )
            }
            tableFilter={{}}
            sorters={visibleTotal ? {} : sortStrictFilterRandstad}
            plotlyConfig={{
              responsive: true,
            }}
            tableOptions={{
              realMonths: dataNestedTable.fields?.real_months,
              visibleTotal: visibleTotal,
              clickCallback: (info, value, record, pivotData, vals) => {
                if (canDelete) {
                  if (_.isEmpty(dataCell) && info.target.className !== 'pvtTotal') {
                    setDataCell(record)

                    const originElement = info.target.innerHTML
                    const newElement = info.target

                    newElement.innerHTML = `<input type="number" step="0.00" value="${
                      value ?? 0
                    }" >`
                    const inputElement = document.querySelector('input[type="number"]')

                    inputElement.focus()

                    const handleInput = (e) => {
                      inputValueRef.current = e.target.value
                    }

                    const handleBlur = () => {
                      newElement.innerHTML = originElement
                      inputElement.removeEventListener('input', handleInput)
                      inputElement.removeEventListener('blur', handleBlur)
                      inputElement.removeEventListener('keypress', handleKeyPress)
                      setDataCell({})
                      inputValueRef.current = null
                    }

                    const handleKeyPress = (e) => {
                      if (e.key === 'Enter') {
                        onCellEdit(parseFloat(inputValueRef.current), record, vals, 'base')
                        inputElement.removeEventListener('input', handleInput)
                        inputElement.removeEventListener('blur', handleBlur)
                        inputElement.removeEventListener('keypress', handleKeyPress)
                        setDataCell({})
                        newElement.innerHTML = originElement
                      }
                    }

                    inputElement.addEventListener('input', handleInput)
                    inputElement.addEventListener('blur', handleBlur)
                    inputElement.addEventListener('keypress', handleKeyPress)
                  }
                }
              },
            }}
            {...settings}
          />
        </div>
      </Dropdown>
    </Spin>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

export default connect(mapStateToProps, null)(NestedTable)
